// The customer portal's SAFed explainer (Session BDB, Part 4). Static text, nothing sent. It quotes no figure (the price is on the
// quotation), names no examining body, and never says ELE arranges the customer's thorough examination. House style: plain English,
// no dashes standing in for punctuation, the one client phone number.
export const SAFED_PORTAL_HEADING = "Supplementary safety tests (SAFed)";

export const SAFED_PORTAL_EXPLAINER: readonly string[] = [
  "SAFed tests are extra checks on a lift's safety equipment, such as its safety gear or its overspeed device. They are not part of your service agreement.",
  "Your examiner or your insurer may ask for one, or you can ask us to carry one out. We carry the tests out. We do not carry out thorough examinations, and arranging your thorough examination stays with you.",
  "Before we carry out any stress test, we need your written authorisation, signed by you as the duty holder or by someone authorised to sign for you.",
  "Each test day is quoted as a fixed price, and you approve the quotation before we attend.",
  "If you have a question, call us on 0203 576 4760.",
];

export const SAFED_PORTAL_EMPTY = "There are no supplementary tests recommended, booked or done for this site yet.";
